import React, { useEffect, useState, ChangeEvent, useRef, Fragment } from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
} from 'reactstrap';
import { useUser } from 'context/UserContext';
import { useAlertPlus, useConfirm } from 'hooks';
import DatePicker, { DatePickerChangeEvent } from 'components/DatePicker';
import moment from 'moment';
import Required from 'components/Required';
import ConfirmModal from 'components/ConfirmModal';
import AlertModal from 'components/AlertModal';
import UploaderMultiple from 'components/UploaderMultiple';
import HorariosAtencionComponent from 'components/Consultorios/HorariosAtencion';
import { useHistory } from 'react-router-dom';
import { getPartidos } from '../../features/partidos/partidosAPI';
import { Partidos } from 'types/Partidos';
import { getLocalidades } from '../../features/localidades/localidadesAPI';
import { Localidades } from 'types/Localidades';
import {
  getAllConsultoriosCokiba,
} from '../../features/consultorios/consultoriosAPI';
import {
  postFacturacionOOSS,
} from '../../features/facturacionooss/facturacionoossAPI';
import {
  getSucursalesBancarias,
} from '../../features/sucursalesbancarias/sucursalesbancariasAPI';
import {
  ConsultorioCokiba,
} from 'types/Consultorio';
import {
  FacturacionOOSSRequest,
  FacturacionOOSSConsultorio,
  FacturacionOOSSConsultorioHorario,
} from 'types/FacturacionOOSS';
import {
  SucursalesBancarias,
} from 'types/SucursalesBancarias';
import { useTotp } from 'hooks/useTotp';

export default function CreateSolicitudFacturacionOOSS() {
  const { getMatricula } = useUser();
  const matriculateId = getMatricula();
  if (!matriculateId) {
    return null;
  }

  const history = useHistory();

  const [formValidation, setFormValidation] = useState<any>({});

  const [disableSend, setDisableSend] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const [showAlert, message, alertCallback, alert] = useAlertPlus('');
  const [confirm, confirmTitle, confirmAction, setConfirm] = useConfirm(false);

  const formElement = useRef<HTMLFormElement | null>(null);

  const [sucursalesBancarias, setSucursalesBancarias] = useState<SucursalesBancarias[]>([]);

  const [partidos, setPartidos] = useState<Partidos[]>([]);

  const [localidadesDomicilio, setLocalidadesDomicilio] = useState<Localidades[]>([]);
  const [partidoDomicilio, setPartidoDomicilio] = useState<number>(0);
  const [localidadDomicilio, setLocalidadDomicilio] = useState<number>(0);

  const [localidadesSinDeclarar, setLocalidadesSinDeclarar] = useState<Localidades[]>([]);
  const [partidoSinDeclarar, setPartidoSinDeclarar] = useState<number>(0);
  const [localidadSinDeclarar, setLocalidadSinDeclarar] = useState<number>(0);

  const [consultorios, setConsultorios] = useState<FacturacionOOSSConsultorio[]>([]);

  const [hasSinDeclarar, setHasSinDeclarar] = useState<boolean>(false);
  const [sinDeclarar, setSinDeclarar] = useState<FacturacionOOSSConsultorio>({
    id: null,
    request_id: null,
    es_habilitado: null,
    consultorio_id: null,
    numero_resolucion: null,
    lugar_atencion_id: null,
    calle: null,
    numero: null,
    piso: null,
    departamento: null,
    id_localidad: null,
    codigo_postal: null,
    prefijo_telefono: null,
    telefono: null,
    horarios_atencion: [],
    localidad: null,
    nombre: null,
    seleccionado: null,
  });
  const [horariosAtencion, setHorariosAtencion] = useState<FacturacionOOSSConsultorioHorario[]>([]);

  const [data, setData] = useState<FacturacionOOSSRequest>({
    id: 0,
    state_id: null,
    matriculate_id: null,
    atencion_domiciliario: null,
    atencion_domiciliario_ioma: null,
    id_localidad: null,
    prefijo_telefono_domicilio: null,
    numero_telefono_domicilio: null,
    numero_rnp: null,
    vencimiento_rnp: null,
    prestador_os: null,
    prestador_ioma: null,
    condicion_iva: null,
    nro_sucursal_banco: null,
    motivo_rechazo: null,
    created_at: null,
    resolved_at: null,
    deleted_at: null,
    user_id: null,
    state: null,
    consultorios: [],
    attachs: [],
  });

  const { requestTotp, TotpModal } = useTotp();

  useEffect(() => {
    setLoading(true);

    const loadData = async () => {
      try {
        const sucursalesBancariasResponse = await getSucursalesBancarias();
        if (sucursalesBancariasResponse) {
          setSucursalesBancarias(sucursalesBancariasResponse);
        }

        const provinciaId = 1; // Buenos Aires
        const partidosResponse = await getPartidos(provinciaId);
        if (partidosResponse) {
          setPartidos(partidosResponse);
        }

        getAllConsultoriosCokiba(matriculateId)
          .then((response: ConsultorioCokiba[]) => {
            const formatedConsultorios: FacturacionOOSSConsultorio[] = [];
            for (const consultorio of response) {
              formatedConsultorios.push({
                id: null,
                request_id: null,
                es_habilitado: !!consultorio.idConsultorioHabilitado,
                consultorio_id: consultorio.idConsultorio,
                numero_resolucion: '',
                lugar_atencion_id: null,
                calle: consultorio.direccion,
                numero: `${consultorio.numero}`,
                piso: consultorio.piso,
                departamento: consultorio.departamento,
                id_localidad: null,
                localidad: consultorio.localidad,
                codigo_postal: consultorio.codigoPostal,
                prefijo_telefono: consultorio.prefijoTelefono,
                telefono: consultorio.numeroTelefono,
                nombre: consultorio.nombreConsultorio,
                horarios_atencion: null,
                seleccionado: false,
              });
            }
            setConsultorios(formatedConsultorios);

            const horarios: FacturacionOOSSConsultorioHorario[] = response.flatMap(consultorio =>
              (consultorio.horarios ?? []).map(horario => ({
                diaSemana: horario.diaSemana,
                horaInicio: horario.horaInicio,
                horaFin: horario.horaFin,
              })),
            );
            setHorariosAtencion(horarios);
          })
          .catch(err => {
            alert(true, err.getMessage() || 'No se puedieron obtener los consultorios del matriculado');
          })
          .finally(() => {
            setLoading(false);
          });
      } catch (err) {
        setDisableSend(true);
        alert(
          'Se produjo un error al intentar recuperar información inicial. ' +
            'Por favor, intente nuevamente más tarde.',
        );
        console.error('FacturacionOOSSCreate', 'Error al cargar datos iniciales');
        console.info(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  useEffect(() => {
    if (!!matriculateId) {
      setData(prev => ({
        ...prev,
        matriculate_id: +matriculateId || null,
      }));
    }
  }, [matriculateId]);

  useEffect(() => {
    setLoading(true);

    const loadLocalidades = async () => {
      try {
        const localidadesResponse = await getLocalidades(partidoSinDeclarar);
        if (localidadesResponse) {
          setLocalidadesSinDeclarar(localidadesResponse);
        }
      } catch (err) {
        setDisableSend(true);
        alert(
          'Se produjo un error al intentar recuperar las localidades. ' +
            'Por favor, intente nuevamente más tarde.',
        );
        console.error('ConsultoriosCreate', 'Error al cargar las localidades');
        console.info(err);
      } finally {
        setLoading(false);
      }
    };

    loadLocalidades();
  }, [partidoSinDeclarar]);

  useEffect(() => {
    setLoading(true);

    const loadLocalidades = async () => {
      try {
        const localidadesResponse = await getLocalidades(partidoDomicilio);
        if (localidadesResponse) {
          setLocalidadesDomicilio(localidadesResponse);
        }
      } catch (err) {
        setDisableSend(true);
        alert(
          'Se produjo un error al intentar recuperar las localidades. ' +
            'Por favor, intente nuevamente más tarde.',
        );
        console.error('ConsultoriosCreate', 'Error al cargar las localidades');
        console.info(err);
      } finally {
        setLoading(false);
      }
    };

    loadLocalidades();
  }, [partidoDomicilio]);

  const validarHorarios = (): boolean => {
    if (sinDeclarar.horarios_atencion?.length === 0) {
      alert(`Se debe cargar al menos un día y horarios de atención.`);
      return false;
    }

    const horarios = [
      ...horariosAtencion,
      ...sinDeclarar.horarios_atencion ?? [],
    ];

    for (const h of horarios) {
      if (!h.diaSemana || !h.horaInicio || !h.horaFin) {
        alert('Todos los campos son obligatorios.');
        return false;
      }

      if (h.horaInicio >= h.horaFin) {
        alert(`La hora de inicio debe ser anterior a la hora de fin (${h.diaSemana}).`);
        return false;
      }
    }

    // Validar solapamientos en un mismo día
    for (let i = 0; i < horarios.length; i++) {
      for (let j = i + 1; j < horarios.length; j++) {
        const h1 = horarios[i];
        const h2 = horarios[j];
        if (h1.diaSemana?.toUpperCase() === h2.diaSemana?.toUpperCase()) {
          const inicio1 = h1.horaInicio;
          const fin1 = h1.horaFin;
          const inicio2 = h2.horaInicio;
          const fin2 = h2.horaFin;

          if (
            (!!inicio1 && !!inicio2 && !!fin2 && !!fin1) &&
            (
              (inicio1 < fin2 && fin1 > inicio2) || // solapamiento
              inicio1 === inicio2
            )
          ) {
            alert(`Hay horarios superpuestos el día ${h1.diaSemana}.`);
            return false;
          }
        }
      }
    }

    return true;
  };

  const handleFormValidation = () => {
    let newFormValidation = {};

    let toValidate = [
      ...Array.from(document.getElementsByClassName('form-control')),
    ] as HTMLInputElement[];
    toValidate = toValidate.filter(e => !e.disabled && e.required);

    let missing = false;
    // Validar campos required
    toValidate.forEach(field => {
      if (field.required && !field.disabled && !field.value?.trim()) {
        field.classList.add('is-invalid');

        missing = true;
      } else if (field.inputMode === 'numeric') {
        if (!/^\d+$/.test(field.value)) {
          newFormValidation = {
            ...newFormValidation,
            [field.name]: false,
          };
        }
      } else {
        field.classList.remove('is-invalid');
      }
    });

    consultorios.map(consultorio => {
      if (consultorio.seleccionado) {
        if (!consultorio.numero_resolucion) {
          const numeroResolucion =
            document.getElementById(`numero_resolucion_${consultorio.consultorio_id}`) as HTMLInputElement;
          if (!!numeroResolucion) {
            numeroResolucion.classList.add('is-invalid');
            missing = true;
          }
        }
      } else {
        const numeroResolucion =
          document.getElementById(`numero_resolucion_${consultorio.consultorio_id}`) as HTMLInputElement;
        if (!!numeroResolucion) {
          numeroResolucion.classList.remove('is-invalid');
        }
      }
    });

    if (missing) {
      setFormValidation(newFormValidation);
      alert(
        'Todos los campos marcados con * son obligatorios. ' +
          'Por favor complete los faltantes antes de enviar la solicitud.',
      );
      return false;
    }


    if (!!hasSinDeclarar) {
      return validarHorarios();
    } else {
      return true;
    }
  };

  // Confirmación de envío de Solicitud
  const handleSendForm = () => {
    if (!handleFormValidation()) {
      return;
    }

    setConfirm(
      true,
      '¿Estás seguro que deseas enviar esta solicitud de consultorio?',
      'send',
    );
  };

  // Gestor de respuestas de confirmaciones
  const handleConfirmation = (action: string) => {
    if (action === 'send') {
      handleSend();
    }

    setConfirm(false);
  };

  // Envío de solicitudes
  const handleSend = async () => {
    setFormValidation({});

    setLoading(true);

    // Preparamos los datos menos los archivos
    const consultoriosBody: FacturacionOOSSConsultorio[] = [];
    consultorios.map(consultorio => {
      if (consultorio.seleccionado) {
        consultoriosBody.push({
          id: null,
          es_habilitado: consultorio.es_habilitado,
          consultorio_id: consultorio.consultorio_id,
          numero_resolucion: consultorio.numero_resolucion,
          lugar_atencion_id: null,
          calle: consultorio.calle,
          numero: consultorio.numero,
          piso: consultorio.piso,
          departamento: consultorio.departamento,
          id_localidad: null,
          codigo_postal: consultorio.codigo_postal,
          prefijo_telefono: consultorio.prefijo_telefono,
          telefono: consultorio.telefono,
          horarios_atencion: null,
        });
      }
    });

    if (hasSinDeclarar) {
      consultoriosBody.push({
        id: null,
        es_habilitado: false,
        consultorio_id: null,
        numero_resolucion: null,
        lugar_atencion_id: null,
        calle: sinDeclarar.calle,
        numero: sinDeclarar.numero,
        piso: sinDeclarar.piso,
        departamento: sinDeclarar.departamento,
        id_localidad: localidadSinDeclarar,
        codigo_postal: sinDeclarar.codigo_postal,
        prefijo_telefono: sinDeclarar.prefijo_telefono,
        telefono: sinDeclarar.telefono,
        horarios_atencion: sinDeclarar.horarios_atencion,
      });
    }

    const facturacionOOSS: Partial<FacturacionOOSSRequest> = {
      atencion_domiciliario: data.atencion_domiciliario,
      atencion_domiciliario_ioma: data.atencion_domiciliario_ioma,
      id_localidad: localidadDomicilio ?? null,
      prefijo_telefono_domicilio: data.prefijo_telefono_domicilio,
      numero_telefono_domicilio: data.numero_telefono_domicilio,
      numero_rnp: data.numero_rnp,
      vencimiento_rnp: data.vencimiento_rnp,
      prestador_os: data.prestador_os,
      prestador_ioma: data.prestador_ioma,
      condicion_iva: data.condicion_iva,
      nro_sucursal_banco: data.nro_sucursal_banco,
      consultorios: consultoriosBody,
    };

    // Preparamos los archivos
    const files: Record<string, File> = {};
    const inputs = Array.from(document.querySelectorAll('input[type="file"]'));
    for (const inputElement of inputs) {
      const input = inputElement as HTMLInputElement;
      if (input.hasAttribute('required') && input.value === '') {
        alert(
          'Faltan subir archivos requeridos para poder enviar la solicitud.',
        );
        setLoading(false);
        return;
      }

      if (input.files) {
        for (let i = 0; i < input.files.length; i++) {
          files[`${input.name}_${i}`] = input.files[i];
        }
      }
    }

    const code = await requestTotp('facturacion_ooss');
    if (!code) return;

    // Enviamos la petición
    await postFacturacionOOSS(facturacionOOSS, files, code)
      .then(res => {
        if (!res || res.status != 'ok') {
          // Error interno
          console.error('FacturacionOOSSCreate', 'Error al enviar la solicitud');
          console.info(res);
          alert(
            res.message ??
            'Ha ocurrido un error al enviar la solicitud. Por favor intente nuevamente.',
          );
          return;
        }

        alert('La solicitud se envió correctamente', () => {
          history.push('/facturacion-ooss');
        });
      })
      .catch(err => {
        console.error(
          'FacturacionOOSSCreate',
          'Error inesperado al intentar enviar la solicitud',
        );
        console.info(err);
        alert(
          'Ha ocurrido un error al enviar la solicitud. Por favor intente nuevamente.',
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement> | DatePickerChangeEvent) => {
    const { target } = event;

    const name = target.name;

    let value: string | number | boolean | Date | null;

    value = target.value;

    if (target.type === 'checkbox') {
      value = target.checked;
    }

    if (name == 'atencion_domiciliario' && !value) {
      setPartidoDomicilio(0);
      setLocalidadDomicilio(0);
    }

    // Guardamos el nuevo valor
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleCheckboxConsultorioChange = (consultorioId: number | null) => {
    if (consultorioId === null) return;

    setConsultorios(prevConsultorios =>
      prevConsultorios.map(c =>
        c.consultorio_id === consultorioId
          ? { ...c, seleccionado: !c.seleccionado }
          : c,
      ),
    );
  };

  const handleNumeroResolucionChange = (
    consultorioId: number | null,
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    if (consultorioId === null) return;
    const { target } = event;
    const value: string = target.value;

    setConsultorios(prevConsultorios =>
      prevConsultorios.map(c =>
        c.consultorio_id === consultorioId
          ? { ...c, numero_resolucion: value }
          : c,
      ),
    );
  };

  const handleInputChangeSinDeclarar = (event: ChangeEvent<HTMLInputElement>) => {
    const { target } = event;

    const name = target.name;

    let value: string | number | boolean | null;

    value = target.value;

    if (target.type === 'checkbox') {
      value = target.checked;
    }

    // Guardamos el nuevo valor
    setSinDeclarar({
      ...sinDeclarar,
      [name]: value,
    });
  };

  return (
    <div className="content">
      <Row>
        <Col sm={12}>
          <Card>
            <CardHeader>
              <Row style={{ alignItems: 'center' }}>
                <Col sm={8}>
                  <CardTitle tag="h5">Alta de Facturación en Obras Sociales</CardTitle>
                </Col>
                <Col sm={4} className="text-right">
                  <Button
                    className="btn-round"
                    color="primary"
                    onClick={() => {
                      history.push(`/facturacion-ooss`);
                    }}
                  >
                    Volver
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Form innerRef={formElement}>
                <Col sm={12}>
                  <p><u>Requisitos para la inscripción como prestador</u>:</p>
                  <ul>
                    <li>Poseer un domicilio de atención en la Provincia de Buenos Aires.</li>
                    <li>Estar inscripto en la A.F.I.P.</li>
                    <li>
                      Poseer certificado de Inscripción en el Registro de Prestadores de la Superintendencia de Salud
                      (Ministerio de Salud Nación) donde conste el número de Matrícula del Colegio de Kinesiólogos de
                      la Provincia de Buenos Aires
                    </li>
                    <li>
                      Adjuntar Habilitación definitiva o en trámite del consultorio o establecimiento donde trabajará
                      (se exceptúa de este requisito si solo trabajará a domicilio).
                    </li>
                  </ul>
                  <p>
                    IMPORTANTE: Los colegas que soliciten la incorporación voluntaria al sistema de Obra Sociales,
                    deberán prestar servicios a Todas las Obras Sociales y Prepagas con las que el Colegio mantiene
                    convenio.
                  </p>
                  <p><u>Alta Efectiva</u>:</p>
                  <ul>
                    <li>
                      Una vez presentada la documentación correspondiente completa y sea validada, el alta solicitada
                      será producida y aprobada por el Consejo Ejecutivo y se considerará vigente a partir del primer
                      día hábil del mes siguiente de la prestación, momento en el que el Profesional solicitante podrá
                      comenzar a facturar prestaciones con cargo a las Obras Sociales con convenio vigente.
                    </li>
                  </ul>
                  <p>
                    IMPORTANTE: Los formularios poseen carácter de Declaración Jurada, deberán estar completos con
                    letra clara y legible con la firma y el sello del profesional donde conste la matrícula provincial
                    otorgada por el Colegio.
                  </p>
                  <p>
                    Si se da de alta en IOMA, se deberá enviar adicionalmente la Plantilla de Adhesión a IOMA, la cual
                    puede ser descargada (
                    <a
                      href=
                        "https://www.cokiba.org.ar/wp-content/uploads/2022/06/planilla_adhesion_IOMA-1_rellenar-1.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      click aquí
                    </a>
                    ).
                    Se deberá adjuntar completa, firmada y sellada para ser validada por el equipo de matrículas.
                  </p>
                </Col>
                <hr className="my-4" />
                <FormGroup>
                  <Row>
                    <Col
                      sm={12}
                      style={{
                        alignContent: 'center',
                      }}
                    >
                      <Input
                        id={`prestador_os`}
                        name={`prestador_os`}
                        type="checkbox"
                        checked={!!data.prestador_os}
                        onChange={handleInputChange}
                        disabled={isLoading}
                      />
                      <Label
                        for={`prestador_os`}
                        style={{
                          marginBottom: 0,
                          marginLeft: '5px',
                          verticalAlign: 'bottom',
                        }}
                      >
                        Alta en OOSS
                      </Label>
                    </Col>
                    <Col
                      sm={12}
                      style={{
                        alignContent: 'center',
                      }}
                    >
                      <Input
                        id={`prestador_ioma`}
                        name={`prestador_ioma`}
                        type="checkbox"
                        checked={!!data.prestador_ioma}
                        onChange={handleInputChange}
                        disabled={isLoading}
                      />
                      <Label
                        for={`prestador_ioma`}
                        style={{
                          marginBottom: 0,
                          marginLeft: '5px',
                          verticalAlign: 'bottom',
                        }}
                      >
                        Alta en IOMA
                      </Label>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col sm={6}>
                      <Label for="numero_rnp">
                        Número RNP <Required />
                      </Label>
                      <Input
                        id="numero_rnp"
                        name="numero_rnp"
                        value={data.numero_rnp ?? ''}
                        invalid={formValidation.numero_rnp === false}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      />
                    </Col>
                    <Col sm={6}>
                      <Label for="vencimiento_rnp">
                        Vencimiento RNP <Required />
                      </Label>
                      <DatePicker
                        id="vencimiento_rnp"
                        name="vencimiento_rnp"
                        selected={
                          data.vencimiento_rnp
                            ? moment(data.vencimiento_rnp).toDate()
                            : ''
                        }
                        dateFormat="dd/MM/yyyy"
                        locale="es"
                        className="date-picker form-control"
                        minDate={moment().toDate()}
                        disabled={isLoading}
                        onChange={date => {
                          handleInputChange({
                            target: {
                              name: 'vencimiento_rnp',
                              type: 'datepicker',
                              value: date,
                            },
                          });
                        }}
                        autoComplete="off"
                        required
                      />
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row>
                    <Col md="6">
                      <Label for="condicion_iva">
                        Condición IVA <Required />
                      </Label>
                      <Input
                        id="condicion_iva"
                        name="condicion_iva"
                        type="select"
                        className="custom-select form-control"
                        value={data.condicion_iva ?? ''}
                        invalid={formValidation.condicion_iva === false}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      >
                        <option value="">Seleccione una opción...</option>
                        <option value="EXENTO">Exento</option>
                        <option value="MONOTRIBUTO">Monotributista</option>
                        <option value="RI">Responsable Inscripto</option>
                      </Input>
                    </Col>
                    <Col md="6">
                      <Label for="nro_sucursal_banco">
                        Sucursal Bancaria <Required />
                      </Label>
                      <Input
                        id="nro_sucursal_banco"
                        name="nro_sucursal_banco"
                        type="select"
                        className="custom-select form-control"
                        value={data.nro_sucursal_banco ?? ''}
                        invalid={formValidation.nro_sucursal_banco === false}
                        onChange={handleInputChange}
                        disabled={isLoading}
                        required
                      >
                        <option value="">Seleccione una opción...</option>
                        {sucursalesBancarias?.map(item => {
                          return (
                            <option
                              key={item.MTR040_N_SUCURSAL}
                              value={item.MTR040_N_SUCURSAL}
                            >
                              {item.MTR040_D_SUCURSAL}
                            </option>
                          );
                        })}
                      </Input>
                    </Col>
                  </Row>
                </FormGroup>
                <hr className="my-4" />
                <Col sm={12}>
                  <CardTitle>Atención a Domicilio</CardTitle>
                </Col>
                <FormGroup>
                  <Row>
                    <Col
                      sm={12}
                      style={{
                        alignContent: 'center',
                      }}
                    >
                      <Input
                        id={`atencion_domiciliario`}
                        name={`atencion_domiciliario`}
                        type="checkbox"
                        checked={!!data.atencion_domiciliario}
                        invalid={formValidation.atencion_domiciliario === false}
                        onChange={handleInputChange}
                        disabled={isLoading || !data.prestador_os}
                      />
                      <Label
                        for={`atencion_domiciliario`}
                        style={{
                          marginBottom: 0,
                          marginLeft: '5px',
                          verticalAlign: 'bottom',
                        }}
                      >
                        Atiende a Domicilio Obras Sociales
                      </Label>
                    </Col>
                    <Col
                      sm={12}
                      style={{
                        alignContent: 'center',
                      }}
                    >
                      <Input
                        id={`atencion_domiciliario_ioma`}
                        name={`atencion_domiciliario_ioma`}
                        type="checkbox"
                        checked={!!data.atencion_domiciliario_ioma}
                        invalid={formValidation.atencion_domiciliario_ioma === false}
                        onChange={handleInputChange}
                        disabled={isLoading || !data.prestador_ioma}
                      />
                      <Label
                        for={`atencion_domiciliario_ioma`}
                        style={{
                          marginBottom: 0,
                          marginLeft: '5px',
                          verticalAlign: 'bottom',
                        }}
                      >
                        Atiende a Domicilio IOMA
                      </Label>
                    </Col>
                  </Row>
                </FormGroup>
                { !!data.atencion_domiciliario || !!data.atencion_domiciliario_ioma
                  ?
                    <>
                      <FormGroup>
                        <Row>
                          <Col md="6">
                            <Label for="partidoDomicilio">
                              Partido <Required />
                            </Label>
                            <Input
                              id="partidoDomicilio"
                              name="partidoDomicilio"
                              type="select"
                              className="custom-select form-control"
                              value={partidoDomicilio ?? ''}
                              invalid={formValidation.partidoDomicilio === false}
                              onChange={e => setPartidoDomicilio(+e.target.value)}
                              disabled={isLoading}
                              required
                            >
                              <option value="">Seleccione una opción...</option>
                              {partidos?.map(item => {
                                return (
                                  <option
                                    key={item.MTR038_ID_PARTIDO}
                                    value={item.MTR038_ID_PARTIDO}
                                  >
                                    {item.MTR038_D_PARTIDO}
                                  </option>
                                );
                              })}
                            </Input>
                          </Col>
                          <Col md="6">
                            <Label for="localidadDomicilio">
                              Localidad <Required />
                            </Label>
                            <Input
                              id="localidadDomicilio"
                              name="localidadDomicilio"
                              type="select"
                              className="custom-select form-control"
                              value={localidadDomicilio ?? ''}
                              invalid={formValidation.localidadDomicilio === false}
                              onChange={e => setLocalidadDomicilio(+e.target.value)}
                              disabled={isLoading}
                              required
                            >
                              <option value="">Seleccione una opción...</option>
                              {localidadesDomicilio?.map(item => {
                                return (
                                  <option
                                    key={item.MTR008_ID_LOCALIDAD}
                                    value={item.MTR008_ID_LOCALIDAD}
                                  >
                                    {item.MTR008_D_LOCALIDAD}
                                  </option>
                                );
                              })}
                            </Input>
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row>
                          <Col sm={2}>
                            <Label for="prefijo_telefono_domicilio">
                              Prefijo Teléfono <Required />
                            </Label>
                            <Input
                              id="prefijo_telefono_domicilio"
                              name="prefijo_telefono_domicilio"
                              value={data.prefijo_telefono_domicilio ?? ''}
                              invalid={formValidation.prefijo_telefono_domicilio === false}
                              onChange={handleInputChange}
                              disabled={isLoading}
                              required
                            />
                          </Col>
                          <Col sm={4}>
                            <Label for="numero_telefono_domicilio">
                              Número Teléfono <Required />
                            </Label>
                            <Input
                              id="numero_telefono_domicilio"
                              name="numero_telefono_domicilio"
                              value={data.numero_telefono_domicilio ?? ''}
                              invalid={formValidation.numero_telefono_domicilio === false}
                              onChange={handleInputChange}
                              disabled={isLoading}
                              required
                            />
                          </Col>
                        </Row>
                      </FormGroup>
                    </>
                  : null
                }
                <hr className="my-4" />
                <Col sm={12}>
                  <CardTitle>Consultorios</CardTitle>
                </Col>
                <FormGroup>
                  {
                    consultorios.map(consultorio => {
                      return (
                        <Fragment key={consultorio.consultorio_id}>
                          <Row>
                            <Col
                              sm={6}
                              style={{
                                alignContent: 'center',
                              }}
                            >
                              <Input
                                id={`consultorio_${consultorio.consultorio_id}`}
                                name={`consultorio_${consultorio.consultorio_id}`}
                                type="checkbox"
                                checked={!!consultorio.seleccionado}
                                onChange={() => handleCheckboxConsultorioChange(consultorio.consultorio_id)}
                                disabled={isLoading}
                              />
                              <Label
                                for={`consultorio_${consultorio.consultorio_id}`}
                                style={{
                                  marginBottom: 0,
                                  marginLeft: '5px',
                                  verticalAlign: 'bottom',
                                }}
                              >
                                {consultorio.nombre
                                  ? consultorio.nombre + ' - '
                                  : ''
                                }
                                {consultorio.calle}
                                {!!consultorio.numero
                                  ? 'Nro. ' + consultorio.numero
                                  : ''
                                }
                                {consultorio.piso}{consultorio.departamento} -&nbsp;
                                {consultorio.localidad}
                              </Label>
                            </Col>
                            <Col sm={6}>
                              { !consultorio.es_habilitado
                                ?
                                  <>
                                    <Label for={`numero_resolucion_${consultorio.consultorio_id}`}>
                                      Número Resolucion <Required />
                                    </Label>
                                    <Input
                                      id={`numero_resolucion_${consultorio.consultorio_id}`}
                                      name={`numero_resolucion_${consultorio.consultorio_id}`}
                                      value={consultorio.numero_resolucion ?? ''}
                                      // invalid={consultorioValidation.numero_resolucion === false}
                                      onChange={e => handleNumeroResolucionChange(consultorio.consultorio_id, e)}
                                      disabled={isLoading}
                                    />
                                  </>
                                : null
                              }
                            </Col>
                          </Row>
                          <hr className="my-4" />
                        </Fragment>
                      );
                    })
                  }
                  <Row>
                    <Col
                      sm={6}
                      style={{
                        alignContent: 'center',
                      }}
                    >
                      <Input
                        id={`has_sin_declarar`}
                        name={`has_sin_declarar`}
                        type="checkbox"
                        checked={!!hasSinDeclarar}
                        // invalid={formValidation[`consultorio_${sinDeclarar.consultorio_id}`] === false}
                        onChange={() => setHasSinDeclarar(!hasSinDeclarar)}
                        disabled={isLoading}
                      />
                      <Label
                        for={`has_sin_declarar`}
                        style={{
                          marginBottom: 0,
                          marginLeft: '5px',
                          verticalAlign: 'bottom',
                        }}
                      >
                        Declarar Nuevo Consultorio
                      </Label>
                    </Col>
                    <Col sm={6}></Col>
                  </Row>
                </FormGroup>
                { !!hasSinDeclarar
                  ?
                    <>
                      <FormGroup>
                        <Row>
                          <Col sm={6}>
                            <Label for="calle">
                              Calle <Required />
                            </Label>
                            <Input
                              id="calle"
                              name="calle"
                              value={sinDeclarar.calle ?? ''}
                              invalid={formValidation.calle === false}
                              onChange={handleInputChangeSinDeclarar}
                              disabled={isLoading}
                              required
                            />
                          </Col>
                          <Col sm={6}>
                            <Label for="numero">
                              Número <Required />
                            </Label>
                            <Input
                              id="numero"
                              name="numero"
                              value={sinDeclarar.numero ?? ''}
                              invalid={formValidation.numero === false}
                              onChange={handleInputChangeSinDeclarar}
                              disabled={isLoading}
                              required
                            />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row>
                          <Col sm={6}>
                            <Label for="piso">
                              Piso
                            </Label>
                            <Input
                              id="piso"
                              name="piso"
                              value={sinDeclarar.piso ?? ''}
                              invalid={formValidation.piso === false}
                              onChange={handleInputChangeSinDeclarar}
                              disabled={isLoading}
                            />
                          </Col>
                          <Col sm={6}>
                            <Label for="departamento">
                              Departamento
                            </Label>
                            <Input
                              id="departamento"
                              name="departamento"
                              value={sinDeclarar.departamento ?? ''}
                              invalid={formValidation.departamento === false}
                              onChange={handleInputChangeSinDeclarar}
                              disabled={isLoading}
                            />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row>
                          <Col sm={2}>
                            <Label for="prefijo_telefono">
                              Prefijo Teléfono <Required />
                            </Label>
                            <Input
                              id="prefijo_telefono"
                              name="prefijo_telefono"
                              value={sinDeclarar.prefijo_telefono ?? ''}
                              invalid={formValidation.prefijo_telefono === false}
                              onChange={handleInputChangeSinDeclarar}
                              disabled={isLoading}
                              required
                            />
                          </Col>
                          <Col sm={4}>
                            <Label for="telefono">
                              Teléfono
                            </Label>
                            <Input
                              id="telefono"
                              name="telefono"
                              value={sinDeclarar.telefono ?? ''}
                              invalid={formValidation.telefono === false}
                              onChange={handleInputChangeSinDeclarar}
                              disabled={isLoading}
                              required
                            />
                          </Col>
                          <Col sm={6}>
                            <Label for="codigo_postal">
                              Código Postal <Required />
                            </Label>
                            <Input
                              id="codigo_postal"
                              name="codigo_postal"
                              value={sinDeclarar.codigo_postal ?? ''}
                              invalid={formValidation.codigo_postal === false}
                              onChange={handleInputChangeSinDeclarar}
                              disabled={isLoading}
                              required
                            />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row>
                          <Col md="6">
                            <Label for="partidoSinDeclarar">
                              Partido <Required />
                            </Label>
                            <Input
                              id="partidoSinDeclarar"
                              name="partidoSinDeclarar"
                              type="select"
                              className="custom-select form-control"
                              value={partidoSinDeclarar ?? ''}
                              invalid={formValidation.partidoSinDeclarar === false}
                              onChange={e => setPartidoSinDeclarar(+e.target.value)}
                              disabled={isLoading}
                              required
                            >
                              <option value="">Seleccione una opción...</option>
                              {partidos?.map(item => {
                                return (
                                  <option
                                    key={item.MTR038_ID_PARTIDO}
                                    value={item.MTR038_ID_PARTIDO}
                                  >
                                    {item.MTR038_D_PARTIDO}
                                  </option>
                                );
                              })}
                            </Input>
                          </Col>
                          <Col md="6">
                            <Label for="localidadSinDeclarar">
                              Localidad <Required />
                            </Label>
                            <Input
                              id="localidadSinDeclarar"
                              name="localidadSinDeclarar"
                              type="select"
                              className="custom-select form-control"
                              value={localidadSinDeclarar ?? ''}
                              invalid={formValidation.localidadSinDeclarar === false}
                              onChange={e => setLocalidadSinDeclarar(+e.target.value)}
                              disabled={isLoading}
                              required
                            >
                              <option value="">Seleccione una opción...</option>
                              {localidadesSinDeclarar?.map(item => {
                                return (
                                  <option
                                    key={item.MTR008_ID_LOCALIDAD}
                                    value={item.MTR008_ID_LOCALIDAD}
                                  >
                                    {item.MTR008_D_LOCALIDAD}
                                  </option>
                                );
                              })}
                            </Input>
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Row className="mt-4 mb-2">
                          <Col md="6">
                            <Label for="documentacion">
                              Días y horarios de atención <Required />
                            </Label>
                            <HorariosAtencionComponent
                              value={sinDeclarar.horarios_atencion ?? []}
                              actuales={horariosAtencion}
                              onChange={horarios =>
                                setSinDeclarar({ ...sinDeclarar, horarios_atencion: horarios })
                              }
                              disabled={isLoading}
                            />
                          </Col>
                        </Row>
                      </FormGroup>
                    </>
                  : null
                }
                <hr className="my-4" />
                <Col sm={12}>
                  <CardTitle>Adjuntos</CardTitle>
                </Col>
                <FormGroup>
                  <Row className="mt-4 mb-2">
                    <Col md="6" className="mt-4 mb-2">
                      <Label for="registro_prestadores">
                        Registro Nacional de Prestadores <Required />
                      </Label><br/>
                      <UploaderMultiple
                        name="registro_prestadores"
                        required
                      />
                    </Col>
                    <Col md="6" className="mt-4 mb-2">
                      <Label for="constancia_afip">
                        Constancia Situación Ante AFIP <Required />
                      </Label><br/>
                      <UploaderMultiple
                        name="constancia_afip"
                        required
                      />
                    </Col>
                    <Col md="6" className="mt-4 mb-2">
                      <Label for="inscripcion_iibb">
                        Inscripción IIBB ARBA <Required />
                      </Label><br/>
                      <UploaderMultiple
                        name="inscripcion_iibb"
                        required
                      />
                    </Col>
                    { !!data.prestador_ioma
                      ?
                        <Col md="6" className="mt-4 mb-2">
                          <Label for="adhesion_ioma">
                            Planilla de Adhesión IOMA <Required />
                          </Label><br/>
                          <UploaderMultiple
                            name="adhesion_ioma"
                            required
                          />
                        </Col>
                      : null
                    }
                    { !!hasSinDeclarar
                      ?
                        <Col md="6" className="mt-4 mb-2">
                          <Label for="declaracion_consultorio">
                            Habilitacion Ministerial <Required />
                          </Label><br/>
                          <UploaderMultiple
                            name="declaracion_consultorio"
                            required
                          />
                        </Col>
                      : null
                    }
                  </Row>
                </FormGroup>
                <p>
                  Declaro bajo juramento que los datos contenidos en la presente son correctos y sin omisión alguna.
                  Declaro conocer y aceptar los reglamentos vigentes en Colegio, para la atención de Obras Sociales y
                  las condiciones previstas en los respectivos convenios. Me comprometo a prestar servicios de la
                  kinesiología respetando las normas operativas actuales o las que se dicten en un futuro, ya sean
                  emanadas del Colegio, de la Obra Social, o de organismos Nacionales, Provinciales y/o Municipales,
                  facultando al Colegio en caso de incumplimiento a darme de baja del parón respectivo bajo mi
                  exclusiva responsabilidad.
                </p>
                <FormGroup>
                  <div className="text-center">
                    <Button
                      type="button"
                      className="btn-round"
                      onClick={handleSendForm}
                      disabled={isLoading || disableSend}
                    >
                      Solicitar
                    </Button>
                  </div>
                </FormGroup>
              </Form>
              <AlertModal
                isOpen={showAlert}
                message={message}
                onClose={alertCallback}
              />
              <ConfirmModal
                isOpen={confirm}
                title={confirmTitle}
                action={confirmAction}
                onClose={() => setConfirm(false)}
                onConfirm={handleConfirmation}
              />
              {TotpModal}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
